/**
 * Created by Vladislav on 19.03.2026.
 */

const ComponentUtils = {
    findChildByName: function (parent, name) {
        if (parent.getName() === name) {
            return parent;
        }
        for (let i = 0; i < parent.children.length; i++) {
            const child = parent.children[i];
            if (child.getName() === name) {
                return child;
            }
            const found = ComponentUtils.findChildByName(child, name);
            if (found) {
                return found;
            }
        }
        return null;
    },

    findComponent: function (root, ComponentClass) {
        const component = ComponentMap.get(root, ComponentClass);
        if (component) {
            return component;
        }
        for (let i = 0; i < root.children.length; i++) {
            const found = ComponentUtils.findComponent(root.children[i], ComponentClass);
            if (found) {
                return found;
            }
        }
        return null;
    },

    findComponentByName: function (root, componentName) {
        const component = ComponentMap.getByName(root, componentName);
        if (component) {
            return component;
        }
        for (let i = 0; i < root.children.length; i++) {
            const found = ComponentUtils.findComponentByName(root.children[i], componentName);
            if (found) {
                return found;
            }
        }
        return null;
    },

    findComponentInParent: function (node, ComponentClass) {
        for (let current = node; current; current = current.parent) {
            const component = ComponentMap.get(current, ComponentClass);
            if (component) {
                return component;
            }
        }
        return null;
    },

    findChildrenByTag: function (parent, tag) {
        const result = [];
        if (parent.getTag() === tag) {
            result.push(parent);
        }
        for (let i = 0; i < parent.children.length; i++) {
            const found = ComponentUtils.findChildrenByTag(parent.children[i], tag);
            result.push(...found);
        }
        return result;
    }
};